const SignIn = [() => import('../Components/login/sign'), 'SignIn'];
const SignIn2 = [() => import('../Components/login/sign'), 'SignIn2'];
const SignUp = [() => import('../Components/login/sign'), 'SignUp'];
const recommend = [() => import('../Components/home/recommend')];
const bet = [() => import('../Components/bet/bet')];
const Cart = [() => import('../Components/cart'), 'Cart'];
const AnaPage = [() => import('../Components/analysis'), 'AnaPage'];
const trend = [() => import('../Components/trend')];
const personalCenter = [() => import('../Components/personal')];
const WalletPage = [() => import('../Components/wallet'), 'WalletPage'];
const Trans = [() => import('../Components/trans/trans'), 'Trans'];
const trends = [() => import('../Components/trends')];
const charge = [() => import('../Components/charge')];
const chargePay = [() => import('../Components/charge_result')];
const LottoPage = [() => import('../Components/lotto'), 'LottoPage'];
const SlotPage = [() => import('../Components/slot'), 'SlotPage'];
const SecPage = [() => import('../Components/sec'), 'SecPage'];
const BdCardPage = [() => import('../Components/sec/bdCard'), 'BdCardPage'];
const AccPage = [() => import('../Components/sec/acc'), 'AccPage'];
const WDPage = [() => import('../Components/sec/withdraw'), 'WDPage'];
const HisPage = [() => import('../Components/sheet/his'), 'HisPage'];
const IncPage = [() => import('../Components/sec/inc/inc'), 'IncPage'];
const MsgPage = [() => import('../Components/sec/msg'), 'MsgPage'];
const FoundPage = [() => import('../Components/sec/found'), 'FoundPage'];
const Mg = [() => import('../Components/sec/msg1'), 'Mg'];
const WelfarePage = [() => import('../Components/welfare'), 'WelfarePage'];
const Vip = [() => import('../Components/vip'), 'Vip'];
const Prs = [() => import('../Components/sec/pop/ps'), 'Prs'];
const ContractPage = [() => import('../Components/contracts'), 'ContractPage'];
const SubPage = [() => import('../Components/sub'), 'SubPage'];
const ProfPage = [() => import('../Components/profit'), 'ProfPage'];
const trfPage = [() => import('../Components/trs'), 'trfPage'];
const VipPage = [() => import('../Components/vip/vip1'), 'VipPage'];
const Reb = [() => import('../Components/rebate'), 'Reb'];
const PwdPage = [() => import('../Components/sec/pop/pwd'), 'PwdPage'];
const TCGLottoPage = [() => import('../Components/lotto/index2'), 'TCGLottoPage'];
const ActPage0 = [() => import('../Components/act/0'), 'ActPage0'];
const ChangePwd = [() => import('../Components/lg/change'), 'ChangePwd'];

const rts = {
    'login': [1, SignIn2],
    'login1': [9, SignIn],
    'welfare': [8, WelfarePage, 1],
    'cpw': [9, ChangePwd],
    'act/0': [9, ActPage0],
    'agent/fd': [9, trfPage, 1],
    'agent/profit': [9, ProfPage, 1],
    'agent/inc': [9, IncPage, 1, 0],
    'agent/sub': [9, SubPage, 1],
    'lotto': [5, LottoPage, 1],
    'lotto2': [6, TCGLottoPage, 1],
    'myVip': [4, Vip, 1],
    'vip': [9, VipPage],
    'slot': [9, {
        component: SlotPage,
        exact: 1
    }, 1],
    'slot/:cate': [4, SlotPage, 1],
    'agent/contracts': [8, ContractPage, 1],
    'agent/analysis': [3, AnaPage, 1],
    '': [0, {
        component: recommend,
        exact: 1,
    }],
    'bet/:id/:type': [3, bet, 1],
    'trends': [4, trends, 1],
    'agent/msg': [6, MsgPage, 1],
    'msg': [4, {
        component: Mg,
        exact: 1,
    }, 1],
    'msg/:id': [9, Mg, 1],
    'game_history': [9, HisPage, 1],
    'cart/:id': [8, Cart, 1],
    'promotion/:id': [9, trend, 1],
    promotion: [1, {
        component: trend,
        exact: 1,
    }],
    'sec': [4, SecPage, 1],
    'profile': [9, Prs, 1],
    'rebate': [9, Reb, 1],
    'addBk': [5, BdCardPage, 1],
    'set/:p': [9, PwdPage, 1],
    'my': [1, personalCenter, 1],
    'trans': [5, Trans, 1],
    'wallet': [2, WalletPage, 1, 0],
    'found/:type': [9, FoundPage, 1],
    'agent/account': [3, AccPage, 1],
    'agent/teamBet': [9, HisPage, 1],
    'charge': [4, charge, 1, 0],
    'charge_pay': [9, chargePay, 1],
    'withdrawals': [9, WDPage, 1],
    'reg': [2, SignUp]
};

export  const preKs = Object.keys(rts);
preKs.sort((a,b)=>{
    return rts[a][0]-rts[b][0]
})
preKs.forEach(a=>{rts[a].shift()})

const routes = {};
const authRoutes = [];
Object.keys(rts).forEach(o => {
    const c = rts[o];
    const au = c[1];
    routes[o] = c[0];
    if (o.indexOf(':') !== -1) {
        o = new RegExp(o.replace(/:\w+/g, '\\w+'), 'gi');
    }
    if (au) authRoutes.push([o, c[2]])
});

export {routes, authRoutes};
